// sagas/subscriptionSaga.js
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  SUBSCRIPTION_PLAN_REQUEST,
  SUBSCRIPTION_PLAN_SUCCESS,
  SUBSCRIPTION_PLAN_FAILURE,

  ///Term & Condition /Privacy Policy /Refund Policy
  TERMS_REQUEST,
  TERMS_SUCCESS,
  TERMS_FAILURE,
  PRIVACY_REQUEST,
  PRIVACY_SUCCESS,
  PRIVACY_FAILURE,
  REFUND_REQUEST,
  REFUND_SUCCESS,
  REFUND_FAILURE,

  //PKINDEV_COMPANY
  PKINDEV_RESQUEST,
  PKINDEV_RESPOND,

  //PROJECT
  PROJECT_RESQUEST,
  PROJECT_RESPOND,

  //PROJECT PLAN
  PROJECT_PLAN_REQUEST,
  PROJECT_PLAN_RESPOND,
} from "../actions";

import apiSetting from "../../services/setting";

// ฟังก์ชันเรียก

//---------- PROJECT ----------------
function* fetchProject({ payload }) {
  try {
    const response = yield call(apiSetting.getProject_sub, payload); // เรียก API

    yield put({ type: PROJECT_RESPOND, payload: response }); // ส่งข้อมูลสำเร็จ
  } catch (error) {
    yield put({
      type: PROJECT_RESPOND,
      payload: { error: error.message || "Error fetching PROJECT" },
    }); // ส่ง error
  }
}

//---------- PROJECT_PLAN ----------------
function* fetchProject_plan({ payload }) {
  try {
    console.log("fetchProject_PLAN payload:", payload);
    const response = yield call(apiSetting.getProject_plan, payload); // เรียก API

    console.log("response Project_PLAN response:", response);
    yield put({ type: PROJECT_PLAN_RESPOND, payload: response }); // ส่งข้อมูลสำเร็จ
  } catch (error) {
    yield put({
      type: PROJECT_PLAN_RESPOND,
      payload: { error: error.message || "Error fetching PROJECT_PLAN" },
    }); // ส่ง error
  }
}

function* fetchPkindev({ payload }) {
  try {
    const response = yield call(apiSetting.getPkindev, payload); // เรียก API

    yield put({ type: PKINDEV_RESPOND, payload: { data: response.data } }); // ส่งข้อมูลสำเร็จ
  } catch (error) {
    yield put({
      type: PKINDEV_RESPOND,
      payload: { error: error.message || "Error fetching Pkindev" },
    }); // ส่ง error
  }
}

function* fetchSubscriptionPlanApi({ payload }) {
  try {
    // เรียก API ผ่านฟังก์ชันจาก service/apiSettings
    const dataRes = yield call(apiSetting.getSubscriptionPlan, payload);

    // ส่งผลลัพธ์เมื่อสำเร็จ
    yield put({ type: SUBSCRIPTION_PLAN_SUCCESS, payload: dataRes });
  } catch (error) {
    // console.error("Error:", error); // แสดง error log สำหรับ debug
    // ส่ง action ประเภท failure เมื่อเกิดข้อผิดพลาด
    yield put({
      type: SUBSCRIPTION_PLAN_FAILURE,
      payload: error.message || "เกิดข้อผิดพลาด",
    });
  }
}

// API Calls Term & Condition /Privacy Policy /Refund Policy
function* fetchTerms({ payload }) {
  try {
    const response = yield call(apiSetting.getTermsCondition, payload);

    yield put({ type: TERMS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: TERMS_FAILURE, payload: error.message });
  }
}

function* fetchPrivacy({ payload }) {
  try {
    const response = yield call(apiSetting.getPrivacyPolicy, payload);
    yield put({ type: PRIVACY_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: PRIVACY_FAILURE, payload: error.message });
  }
}

function* fetchRefund({ payload }) {
  try {
    const response = yield call(apiSetting.getRefundablePolicy, payload);

    yield put({ type: REFUND_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: REFUND_FAILURE, payload: error.message });
  }
}

export function* watchPkindevRequest() {
  yield takeEvery(PKINDEV_RESQUEST, fetchPkindev);
  yield takeEvery(PROJECT_RESQUEST, fetchProject);
}

export function* watchgetSubscription() {
  yield takeEvery(PROJECT_PLAN_REQUEST, fetchProject_plan); //ดึงแค่ id plan นั้น อันเดียว
  yield takeEvery(SUBSCRIPTION_PLAN_REQUEST, fetchSubscriptionPlanApi); //ดึง Plan ทั้งหมด ของ id_project นั้น
}

// Watcher Saga
export function* watchPolicyRequests() {
  yield takeEvery(TERMS_REQUEST, fetchTerms);
  yield takeEvery(PRIVACY_REQUEST, fetchPrivacy);
  yield takeEvery(REFUND_REQUEST, fetchRefund);
}

export default function* rootSaga() {
  yield all([
    fork(watchPkindevRequest),
    fork(watchgetSubscription),
    fork(watchPolicyRequests),
  ]);
}
